import React, { Component } from 'react';
import { View, Text } from 'react-native';
import utils from '../utils';
import { enabledStyle, disabledStyle } from '../commonStyles';

const statusMap: { [propName: string]: string } = {
    10: 'isWarning',
    11: 'isWarning'
};

const appActionMap: { [propName: string]: boolean } = {
    pay: true
};

const iconMap: { [propName: string]: string } = {
    16001001: '\uf1fc',
    16003001: '\ue033'
};

const iconColorMap: { [propName: string]: string } = {
    16003001: '#ff9800'
};

const titleMap: { [propName: string]: string } = {
    16001: '货币兑换',
    16003: '全球购'
};

interface Props {
    data: {
        productTitle: string;
        hasDate: string;
        date: string;
        exchangeAmount: number;
        supplier: string;
        vouchersTitle: string;
        beginDate: string;
        endDate: string;
        count: number;
        _disable: boolean;
    };
}

class Shopping extends Component<Props> {
    public static formatData(data: any) {
        const newData = { ...data };
        // icon
        newData.iconColor = iconColorMap[newData.orderType] || '#22cad3';
        newData.title = newData.orderTitle || titleMap[newData.sysCode];
        newData.iconfont = iconMap[newData.orderType] || '\uf1fc';
        // 状态
        newData._orderStatus = statusMap[newData.status];
        // 按钮
        newData.actionInfos = utils.buildActionInfos(newData.appAction, appActionMap);
        // 价格
        newData.currency = (newData.currency || '').trim();
        newData.fixPrice = utils.fixPrice(newData.price, newData.currency);
        newData.fixConvertPrice = utils.fixPrice(newData.convertPrice);
        if (newData.currency !== '&yen;') {
            newData.currency += ' ';
        }
        newData.hasDate = utils.buildDateTime(newData.date);

        return newData;
    }

    public render() {
        const {
            data: {
                productTitle,
                hasDate,
                date,
                exchangeAmount,
                supplier,
                vouchersTitle,
                beginDate,
                endDate,
                count,
                _disable
            } = {}
        } = this.props;
        const styles = _disable ? disabledStyle : enabledStyle;

        return (
            <View style={styles.left}>
                <Text numberOfLines={2} style={styles.newOrderTitle}>
                    {productTitle}
                </Text>
                {Boolean(hasDate) && (
                    <Text numberOfLines={1} style={styles.newOrderSubTitle}>
                        {`预约时间  ${date}`}
                    </Text>
                )}
                {Boolean(exchangeAmount) && (
                    <Text numberOfLines={1} style={styles.newOrderSubTitle}>
                        {`兑换金额  ${exchangeAmount}`}
                    </Text>
                )}
                {Boolean(supplier) && (
                    <Text numberOfLines={1} style={styles.newOrderSubTitle}>
                        {`供应商  ${supplier}`}
                    </Text>
                )}
                {Boolean(vouchersTitle) && (
                    <Text numberOfLines={1} style={styles.newOrderSubTitle}>
                        {vouchersTitle}
                    </Text>
                )}
                {Boolean(beginDate && endDate) && (
                    <Text style={styles.newOrderSubTitle} numberOfLines={1}>
                        {`${beginDate} 至 ${endDate}  有效`}
                    </Text>
                )}
                {Boolean(count) && (
                    <Text style={styles.newOrderSubTitle} numberOfLines={1}>
                        {`数量：${count}`}
                    </Text>
                )}
            </View>
        );
    }
}

export default Shopping;
